<template>
  <div ref="globeContainer"></div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "AppGlobe",
  data() {
    return {
      polygonsCount: 0,
      countryColors: ["#FF7537", "#FFD537", "#4D3BBB", "#27B781"]
    };
  },
  computed: mapState({
    hexBinPoints: state => state.hexBinPoints
  }),
  methods: {
    setPolygonData() {
      return fetch(
        "https://globe.gl/example/datasets/ne_110m_admin_0_countries.geojson"
      )
        .then(response => response.json())
        .then(countries => {
          this.$myGlobe.polygonsData(
            countries.features.filter(d => d.properties.ISO_A2 !== "AQ")
          );
        })
        .catch(error => console.log(error));
    },
    polygonCapColor() {
      const color = this.countryColors[
        this.polygonsCount % this.countryColors.length
      ];
      this.polygonsCount += 1;
      return color;
    }
  },
  beforeMount() {
    this.setPolygonData();
    this.$myGlobe
      .polygonCapColor(this.polygonCapColor)
      .polygonSideColor(() => "rgba(0,100,0,0.3)")
      .polygonAltitude(0.01)
      .polygonsTransitionDuration(200)
      .onPolygonHover(hoveredPolygon =>
        this.$myGlobe.polygonAltitude(polygon =>
          polygon === hoveredPolygon ? 0.1 : 0.01
        )
      )
      .polygonLabel(
        polygon => `
        <b>${polygon.properties.NAME}</b>
      `
      )
      .hexBinPointsData(this.hexBinPoints)
      .hexAltitude(({ sumWeight }) => sumWeight * 0.1);
  },
  created() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === "addHexBinPoint") {
        this.$myGlobe.hexBinPointsData(state.hexBinPoints);
      }
    });
  },
  mounted() {
    this.$myGlobe(this.$refs.globeContainer);

    const resizeObserver = new ResizeObserver(entries => {
      const globeContainer = entries[0];
      this.$myGlobe
        .width(globeContainer.contentRect.width)
        .height(globeContainer.contentRect.height);
    });
    resizeObserver.observe(this.$refs.globeContainer);
  },
  unmounted() {
    this.unsubscribe();
  }
};
</script>
